import { AutomationTask, EncampyCommand } from "encampy";

/**
 * Run custom automation tasks on a specified URL
 * @param url The URL to navigate to and run automation on
 * @param tasks Array of AutomationTask objects to execute
 * @throws Error if automation fails
 */
export async function runAutomationTasks(
  url: string,
  tasks: AutomationTask[]
): Promise<void> {
  if (!url || url.trim() === "") {
    throw new Error("URL is required");
  }

  if (!tasks || tasks.length === 0) {
    throw new Error("At least one automation task is required");
  }

  // Validate URL format
  try {
    new URL(url);
  } catch {
    throw new Error("Invalid URL format");
  }

  const { encampyConnection } = await import("./connectionManager");

  console.log("Sending custom automation tasks:", tasks);
  console.log("Target URL:", url);
  console.log("Command:", EncampyCommand.RUN_AUTOMATION_FLOW);

  const response = await encampyConnection.sendMessage({
    command: EncampyCommand.RUN_AUTOMATION_FLOW,
    payload: {
      tasks: tasks,
      url: url,
    },
  });

  console.log("Custom automation response:", response);

  if (!response.success) {
    throw new Error(response.error || "Automation failed");
  }
}
